import { SpecSheet } from "kinnect-models";
import {
	KFileInput,
	KForm,
	KLink,
	KTextField,
	KTextarea
} from "kinnect-general";
import {
	VBtn,
	VIcon,
	VInput
} from "vuetify/lib";
import { objectToFormData } from "object-to-formdata";

export default KForm.extend( {
	name: "SpecSheetForm",

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "specSheets" } ]
		},

		specSheet: SpecSheet
	},

	data: () => ( {
		originalFileUrl: null,
		formFields: {
			description: null,
			file: null,
			manufacturerName: null,
			modelNumber: null,
			partNumber: null,
			productName: null
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.specSheet );
		},

		formUrl() {
			return this.editing
				? `sales/spec-sheets/${this.specSheet.id}?_method=PUT`
				: "sales/spec-sheets";
		},

		formData() {
			return objectToFormData( this.formFields, { indices: true } );
		},

		genFileField() {
			if ( this.originalFileUrl ) {
				return <VInput
					class="mt-4 mb-1"
					prependIcon="attach_file"
				>
					<KLink
						class="pt-2 pb-1"
						href={this.originalFileUrl}
						target="_blank"
					>View Spec Sheet File</KLink>

					<VBtn
						onClick={() => {
							this.formFields.file = null;
							this.originalFileUrl = null;
						}}
						slot="append"
						small
						text
					>
						<VIcon left>close</VIcon> Remove File
					</VBtn>
				</VInput>;
			}

			return <KFileInput
				accept=".gif,.jpg,.jpeg,.png,.doc,.docx,.pdf,.txt,.rtf,.xls,.xlsx,.csv"
				label="Spec Sheet File*"
				required
				vModel={this.formFields.file}
				validationName="file"
				validationRules="required"
			></KFileInput>;
		}
	},

	watch: {
		specSheet: {
			handler( specSheet ) {
				if ( specSheet ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( specSheet.hasOwnProperty( key ) ) {
							this.formFields[key] = specSheet[key];
						}
					} );

					this.originalFileUrl = specSheet.fileUrl;
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formData,
				method: "post"
			}}
			on={this.$listeners}
		>
			{this.genFileField}

			<KTextField
				label="Manufacturer Name*"
				prependIcon="business"
				required
				vModel={this.formFields.manufacturerName}
				validationId="manufacturerName"
				validationName="manufacturer name"
				validationRules="required"
			></KTextField>

			<KTextField
				label="Product Name*"
				prependIcon="shopping_cart"
				required
				vModel={this.formFields.productName}
				validationId="productName"
				validationName="product name"
				validationRules="required"
			></KTextField>

			<KTextField
				class="ml-blank-icon"
				label="Model Number"
				vModel={this.formFields.modelNumber}
				validationId="modelNumber"
				validationName="model number"
			></KTextField>

			<KTextField
				class="ml-blank-icon"
				label="Part Number"
				vModel={this.formFields.partNumber}
				validationId="partNumber"
				validationName="part number"
			></KTextField>

			<KTextarea
				label="Description"
				prependIcon="comment"
				vModel={this.formFields.description}
				validationName="description"
			></KTextarea>
		</KForm>;
	}
} );
